import { render } from "./PreviewLayout.vue?vue&type=template&id=b01763d0"
const script = {}

import "./PreviewLayout.vue?vue&type=style&index=0&id=b01763d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__